// extracted by mini-css-extract-plugin
export default {"root":"search_root__0UMqr","input":"search_input__5VgEP","icon":"search_icon__qav2-","clear":"search_clear__paa10"};